import { ComponentType, FC } from "react"
import { ALL_MODALS, MODAL_CONFIG } from "@/modals/constructor"
import { useModals } from "."

export const Modals: FC = () => {
  const { modals } = useModals()

  return (
    <>
      {ALL_MODALS.map((modalType) => {
        const isOpen = modals[modalType]

        if (!isOpen) {
          return null
        }

        const modalConfig = MODAL_CONFIG[modalType]

        if (!modalConfig || !("component" in modalConfig)) {
          return null
        }

        const ModalComponent = modalConfig.component as ComponentType

        return <ModalComponent key={modalType} />
      })}
    </>
  )
}
